<template>
  <v-autocomplete
    v-model="bindItemValue"
    color="secondary"
    item-color="secondary"
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    :error-messages="combinedErrorMessages"
    :loading="loading"
    :items="selectItems"
    :disabled="disabled"
    clearable
    @change="handleChange"
  >
    <template v-slot:item="{ attrs, item, on }">
      <v-list-item
        v-bind="attrs"
        active-class="secondary elevation-4 white--text"
        class="mx-3 mb-3 v-sheet"
        elevation="0"
        v-on="on"
      >
        <v-list-item-content>
          <v-list-item-title v-text="item[bindText]" />
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
  export default {
    name: 'ResourceSelect',

    props: {
      label: {
        type: String,
        default: 'Select Box Label',
      },
      itemText: {
        type: String,
        default: 'name',
      },
      itemValue: {
        type: String,
        default: 'id',
      },
      bindItem: {
        type: Object,
        default: null,
      },
      bindText: {
        type: String,
        default: 'name',
      },
      bindValue: {
        type: String,
        default: 'id',
      },
      sortBy: {
        type: String,
        default: null,
      },
      fetchMethod: {
        type: Function,
        default: null,
      },
      resource: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      errorMessages: {
        type: Array,
        default: null,
      },
    },

    data: () => ({
      loading: true,
      localErrorMessages: null,
      fetchedItems: null,
    }),

    computed: {
      combinedErrorMessages () {
        return (this.localErrorMessages || this.errorMessages)
      },

      selectItems () {
        let results = this.fetchedItems
        const sortBy = (this.sortBy || this.itemText)
        if (results && sortBy) {
          results = results.sort((a, b) => {
            let aVal = a[sortBy]
            if (aVal !== undefined || aVal !== null) {
              aVal = aVal.toString().toLowerCase()
            }
            let bVal = b[sortBy]
            if (bVal !== undefined || bVal !== null) {
              bVal = bVal.toString().toLowerCase()
            }
            if (aVal < bVal) {
              return -1
            }
            if (aVal > bVal) {
              return 1
            }
            return 0
          })
        }
        return results
      },

      bindItemValue: {
        get: function () {
          return this.bindItem[this.bindValue]
        },
        set: function (val) {
          this.bindItem[this.bindValue] = val
          this.$emit('update:bind-item', this.bindItem)
          this.$emit('update:bindItem', this.bindItem)
        },
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.fetchedItems = null
        this.loading = 'primary'
        this.localErrorMessages = null

        let dataPromise = null
        if (this.fetchMethod) {
          dataPromise = this.fetchMethod()
        } else {
          dataPromise = this.resource.getList()
        }

        dataPromise
          .then(data => {
            this.loading = null
            this.fetchedItems = data
            this.$emit('populated', this.bindItem, this.bindItem[this.bindValue], this.fetchedItems)
          })
          .catch((error) => {
            this.loading = null
            this.showError(error, `Failed to load ${this.label}!`)
          })
      },

      handleChange (selectedValue) {
        this.$emit('change', this.bindItem, selectedValue, this.fetchedItems)
      },

      showError (error, msg) {
        console.log(error)
        this.localErrorMessages = (error || msg)
      },

    },
  }
</script>
